/**
 * Header.
 */

const header = document.getElementById('header');
const headerNavToggle = document.getElementById('header-nav-toggle');

if (headerNavToggle) {
  headerNavToggle.addEventListener('click', () => {
    document.body.classList.toggle('header-nav-visible');
    headerNavToggle.classList.toggle('is-active');
    header.classList.toggle('is-active');
  });
}
